import * as Models from "../models";

export const parseUser = (raw: Models.RawUserInfo): Models.UserInfo => ({
  ...raw,
  creationTime: new Date(raw.creationTime),
  lastSignInTime: raw.lastSignInTime ? new Date(raw.lastSignInTime) : undefined,
});
